"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesClaimAllowOn = void 0;
const type_claim_1 = require("../../types/type.claim");
const index_1 = __importDefault(require("../policies/index"));
const policies = (0, index_1.default)();
function doesClaimAllowOn(claim, resource, action, record) {
    const policyArray = Object.values(policies);
    const claimLevel = claim.level.type;
    // superuser
    if (claim.title === type_claim_1.Roles.ADMINISTRATOR && claim.level.type === '') {
        return true;
    }
    // other users
    return !!policyArray.find((policy) => {
        var _a;
        // make sure the policy role matches the claim role
        return policy.role === claim.title
            // make sure the policy level matches the claim level
            && policy.level === claim.level.type
            // check for the record id
            && claim.level.id === record[claimLevel]
            // check for access
            && ((_a = policy.permissions[resource]) === null || _a === void 0 ? void 0 : _a.find((policyAction) => action.includes(policyAction)));
    });
}
exports.doesClaimAllowOn = doesClaimAllowOn;
